exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a {\r\n    padding-right: 160px;\r\n    background-color: #4dd0c8; \r\n}\r\n\r\n#customers {\r\n    font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    \r\n}\r\n\r\n#customers td, #customers th {\r\n    font-weight: 600;\r\n    font-family: 'lato';\r\n    padding: 8px;\r\n    background: #f5f5f5;\r\n}\r\n\r\n#customers tr:nth-child(even){background-color: #f2f2f2;}\r\n\r\n#customers tr:hover {background-color: #ddd;}\r\n\r\n#customers th {\r\n    text-align: left;\r\n    /* background-color: #4CAF50; */\r\n    color: #292b2c;\r\n    background: #ededed;\r\n    font-weight: lighter;\r\n}\r\n\r\n.sub_tabs li a{\r\n    padding: 15px;\r\n}\r\n.nav-tabs{\r\n    padding: 15px 0px;\r\n    background-color: #4dd0c8;\r\n}\r\n.sub_tabs li a{\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    font-size: 14px;\r\n}\r\n.tab-details {\r\n    padding: 25px 0px;\r\n}\r\n.tab-details img{\r\n    display: block;\r\n    margin: 0 auto;\r\n    padding-bottom: 25px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calculators/home-loan-comparison-calculator/bank-rate-calculation-result/bank-rate-calculation-result.component.css
// module id = 609
// module chunks = 8